import * as dateUtils from "./dateUtils.js";

const DAY = 24 * 3600 * 1000;
export default function (userWord /* plain JSON object */, date) {
  if (userWord.nextDate) {
    if (
      new Date(dateUtils.parse(userWord.previousIntervalDate)).getTime() + DAY >
        date &&
      userWord.previousInterval
    ) {
      return DAY / Math.max(DAY, userWord.previousInterval);
    } else {
      if (userWord.interval) {
        return DAY / Math.max(DAY, userWord.interval);
      } else {
        return 1; // TODO: should use spacedRepetition.NEW_WORD_AVERAGE
        //       but a refactor to avoid cyclic dependency better
      }
    }
  } else {
    return 0;
  }
}
